import { QueryModule } from "@/data/invalidateQueries";
import { useAuthGuardedQuery } from "@/hooks/useAuthGuardedQuery";
import type { AppQueryOptions } from "@/types/react-query";

import { BizJobTitleApi } from "./bizJobTitle.api";
import type { BizJobTitleModels } from "./bizJobTitle.models";

export namespace BizJobTitleQueries {
  export const moduleName = QueryModule.BizJobTitle;

  export const keys = {
    all: [moduleName] as const,
    list: (limit: number, filter?: BizJobTitleModels.BizJobTitlePaginationFilterDto, page?: number, cursor?: string) =>
      [...keys.all, "/biz/job-title/list", limit, filter, page, cursor] as const,
  };

  /**
   * Query `useList`
   * @param { number } object.limit Query parameter. Items per response. Minimum: `1`. Maximum: `100`. Default: `10`
   * @param { BizJobTitleModels.BizJobTitlePaginationFilterDto } object.filter Query parameter
   * @param { number } object.page Query parameter. 1-indexed page number to begin from
   * @param { string } object.cursor Query parameter. ID of item to start after
   * @param { AppQueryOptions } options Query options
   * @returns { UseQueryResult<BizJobTitleModels.BizJobTitlePaginationResponseDto> }
   * @statusCodes [200]
   */
  export const useList = <TData>(
    {
      limit,
      filter,
      page,
      cursor,
    }: { limit: number; filter?: BizJobTitleModels.BizJobTitlePaginationFilterDto; page?: number; cursor?: string },
    options?: AppQueryOptions<typeof BizJobTitleApi.list, TData>,
  ) => {
    return useAuthGuardedQuery({
      queryKey: keys.list(limit, filter, page, cursor),
      queryFn: () => BizJobTitleApi.list(limit, filter, page, cursor),
      ...options,
    });
  };
}
